<template>
  <div class="autocomplete-popup__close-button-container q-d-none q-d-lg-block">
    <button
        id="autocomplete-popup__close-button"
        class="autocomplete-popup__close-button"
        type="button"
        aria-label="Zamknij wyszukiwanie"
        @click="popupStore.hideAutocomplete"
    >
      <svg class="q-close-icon" viewBox="0 0 24 24" aria-hidden="true">
        <path
            d="M6 6l12 12M18 6L6 18"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
        />
      </svg>
    </button>
  </div>
</template>

<script setup lang="ts">
import {usePopupStore} from "@/store/AutocompletePopup/PopupStore";

const popupStore = usePopupStore();
</script>

<style scoped>
#autocomplete-popup__close-button {
  position: absolute;
  top: 5px;
  right: 5px;
  z-index: 1090;
  background: transparent;
  border: none;
  cursor: pointer;

  width: 36px;
  height: 36px;
  display: grid;
  place-items: center;

  color: #6b7280; /* neutral-500; można nadpisać zmienną */
  transition: background 0.15s ease, color 0.15s ease;
}

#autocomplete-popup__close-button .q-close-icon {
  width: 20px;
  height: 20px;
  pointer-events: none;
}

#autocomplete-popup__close-button:hover {
  background: rgba(0,0,0,0.05);
  border-radius: 50%;
  color: #111;
}

#autocomplete-popup__close-button:focus-visible {
  outline: 2px solid rgba(0,0,0,0.2);
  outline-offset: 2px;
  border-radius: 50%;
}


</style>
